import Vue from 'vue'
import PassportEdit from './passport/Edit'
import PassportView from './passport/View'
import DrivingLicenceView from './drivingLicence/View'
import DrivingLicenceEdit from './drivingLicence/Edit'
import Authority from './passport/Authority'

Vue.component('Authority', Authority)
Vue.component('DocumentPassportEdit', PassportEdit)
Vue.component('DocumentPassportView', PassportView)
Vue.component('DocumentDrivingLicenceView', DrivingLicenceView)
Vue.component('DocumentDrivingLicenceEdit', DrivingLicenceEdit)
